// extracted by mini-css-extract-plugin
export default {"productDescription":"B2-z","featuredDescription":"C2-z","description":"D2-z","more":"E2-z","descriptionSku":"F2-z"};